module.exports = __webpack_public_path__ + "8dc95fab9cf98d02ca8d76e97d3dff60.woff";